import React, { useCallback, useEffect } from 'react';

const UPDATE_INTERVAL = 1000; // Update every second

let videoRefObject: HTMLVideoElement | undefined;
export const getVideoRefObject = () => videoRefObject;

// seconds from the loaded playlist's start to the current show's start
let programmeOffset = 0;
export const setProgrammeOffset = (offset: number) => {
  programmeOffset = offset;
};
export const getProgrammeTime = (video: HTMLVideoElement) =>
  Math.max(0, video.currentTime - programmeOffset);

function useCurrentTime(listen = true) {
  const [currentTime, setCurrentTimeState] = React.useState<number>(
    videoRefObject ? getProgrammeTime(videoRefObject) : 0
  );

  const onCurrentTimeUpdate = useCallback(() => {
    if (!videoRefObject) {
      console.warn('Video ref object is undefined. Cannot update current time.');
      return;
    }
    setCurrentTimeState(Math.floor(getProgrammeTime(videoRefObject)));
  }, []);

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined;
    if (listen) {
      onCurrentTimeUpdate();
      interval = setInterval(() => {
        onCurrentTimeUpdate();
      }, UPDATE_INTERVAL);
    }
    return () => {
      clearInterval(interval);
    };
  }, [listen, onCurrentTimeUpdate]);

  const setVideoRefObject = useCallback((ref: HTMLVideoElement) => {
    videoRefObject = ref;
  }, []);

  const setCurrentTime = useCallback((time: number) => {
    if (videoRefObject && videoRefObject.duration) {
      videoRefObject.currentTime = time + programmeOffset;
      setCurrentTimeState(time);
    } else {
      console.warn('Video ref object is undefined. Cannot set current time.');
    }
  }, []);

  const getCurrentTime = useCallback(() => {
    if (videoRefObject) {
      const time = Math.floor(getProgrammeTime(videoRefObject));
      setCurrentTimeState(time);
      return time;
    } else {
      console.warn('Video ref object is undefined. Cannot get current time.');
      return 0;
    }
  }, []);

  return { currentTime, setCurrentTime, setVideoRefObject, getCurrentTime };
}

export default useCurrentTime;
